import { uuid4 as r } from "./chunk1181.js";
function n() {
  return r();
}
function t() {
  return r().substring(16);
}
export {
  t as generateSpanId,
  n as generateTraceId
};
